import { baseApi } from './axios';

export const getDomainConfig = async ({ uiHost }: { uiHost: string }) => {
	const response = await baseApi.post(`/domain-config/ui-host`, { uiHost });
	return response;
};

// export const getDomainConfigByUiHost = async ({ uiHost }: { uiHost: string }) => {
// 	const response = await baseApi.post(`/domain-config/ui-host`, { uiHost });
// 	return response;
// };
